import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../../services/api";
import { useAuth } from "../../../context/AuthContext";
import { useProtectedRoute } from "../../../hooks/useProtectedRoute";
import SupplierForm from "../components/SupplierForm";

const EditSupplierPage: React.FC = () => {
  useProtectedRoute();
  const { token } = useAuth();
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [supplier, setSupplier] = useState<any>(null);
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/inventory/suppliers/${id}`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => setSupplier(res.data))
      .finally(() => setLoading(false));
  }, [id, token]);

  const handleSubmit = async (form: any) => {
    setSaving(true);
    try {
      await api.put(`/inventory/suppliers/${id}`, form, {
        headers: { Authorization: `Bearer ${token}` }
      });
      navigate("/suppliers");
    } catch (err: any) {
      alert(err.response?.data?.message || "Could not update supplier");
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div className="max-w-lg mx-auto p-4">
      <h1 className="text-2xl font-bold mb-6">Edit Supplier</h1>
      <div className="bg-white p-6 rounded shadow">
        <SupplierForm initial={supplier} onSubmit={handleSubmit} saving={saving} />
      </div>
    </div>
  );
};

export default EditSupplierPage;
